import QuestionnaireResource, { SubcategoryResource } from "models/QuestionnaireResource";
import { Questionnaire, Question } from "models/Questionnaire";
import ResultResource from "models/ResultResource";
import Result from "models/Result";


export function QuestionnaireFromResource(questionnaire: QuestionnaireResource): Questionnaire {
	questionnaire.categories.forEach(x => {
		const primary = x.values?.primary;
		primary?.values.forEach((x, index, arr) => {
			if (typeof x.value === 'string') {
				primary.values[index].value = parseInt(x.value);
			}
		});
		const secondary = x.values?.secondary;
		secondary?.values.forEach((x, index, arr) => {
			if (typeof x.value === 'string') {
				secondary.values[index].value = parseInt(x.value);
			}
		});
	});
	return {
		id: questionnaire.id,
		name: questionnaire.name,
		resultName: questionnaire.resultName,
		type: questionnaire.type,
		language: questionnaire.language,
		categories: questionnaire.categories,
		description: questionnaire.description,
		questions: questionnaire.questions.map((x, index) => {
			return {
				id: x.id,
				title: x.title,
				index: index,
				hint: x.hint,
				imageurl: x.imageurl,
				category: questionnaire.categories.find(category => category.id === x.categoryid),
				subcategory: questionnaire.categories.find(category => category.id === x.subcategoryid) as SubcategoryResource,
				answer: {
				}

			} as Question;
		})
	} as Questionnaire;
}

export function ResultFromResource(result: ResultResource) {
	const questionnaire = QuestionnaireFromResource(result.questionnaire);
	questionnaire.questions.forEach((question, index, arr) => {
		question.answer = result.answers.find(x => x.id === question.id);
	});
	return {
		...result,
		questionnaire: questionnaire
	} as Result;
}